import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import confetti from 'canvas-confetti';
import { FiCheckCircle, FiAlertTriangle, FiCopy, FiCheck } from 'react-icons/fi';
import BASE_URL from '../../config/config';
import Loader from '../../components/Loader';

const COLORES_CONFETTI = ['#2c41a3', '#bbc5f1', '#2ecc71', '#ffffff', '#f1c40f'];

// Cortina de confetti cayendo desde el borde superior, repartida por todo el ancho.
const lanzarConfetti = () => {
    let tandas = 0;
    const intervaloLluvia = setInterval(() => {
        tandas += 1;
        confetti({
            particleCount: 3,
            startVelocity: 0,
            ticks: 300,
            gravity: 0.6,
            spread: 90,
            origin: { x: Math.random(), y: -0.1 },
            colors: COLORES_CONFETTI,
        });
        if (tandas >= 60) clearInterval(intervaloLluvia);
    }, 40);
};

const IdentificadorChip = ({ valor }) => {
    const [copiado, setCopiado] = useState(false);

    const copiar = async () => {
        try {
            await navigator.clipboard.writeText(valor);
            setCopiado(true);
            setTimeout(() => setCopiado(false), 1800);
        } catch (error) {
            console.error('Error al copiar el identificador:', error);
        }
    };

    return (
        <button type="button" className="identificador" onClick={copiar} title="Copiar identificador">
            <span className="identificador-texto">
                <span className="identificador-label">Identificador</span>
                <span className="identificador-valor">{valor}</span>
            </span>
            {copiado ? <FiCheck className="identificador-copiar copiado" /> : <FiCopy className="identificador-copiar" />}
        </button>
    );
};

const TicketCreado = () => {
    const { identificador } = useParams(); // Obtener el ID del ticket de los parámetros de la URL
    const [ticket, setTicket] = useState(null);
    const [cargando, setCargando] = useState(true);
    const confettiLanzadoRef = useRef(false);

    const token = localStorage.getItem("AuthToken");

    // Comprobar si el token está presente antes de intentar decodificarlo
    let tokenInfo = {};
    if (token) {
      tokenInfo = jwtDecode(token);
    }

    useEffect(() => {
        const fetchTicket = async () => {
            try {
                const response = await fetch(`${BASE_URL}/ticket/${identificador}`);
                const data = await response.json();
                if (data.ticket.usuario_creador === tokenInfo.usuario || tokenInfo.role === 'admin' || tokenInfo.role === 'tecnico') {
                    setTicket(data.ticket);
                } else {
                    console.error('Error al obtener el ticket:', data.message);
                }
            } catch (error) {
                console.error('Error al obtener el ticket:', error);
            } finally {
                setCargando(false);
            }
        };

        fetchTicket();
    }, [identificador]);

    // Lluvia de confetti al confirmar que el ticket se creó correctamente (una sola vez)
    useEffect(() => {
        if (ticket && !confettiLanzadoRef.current) {
            confettiLanzadoRef.current = true;
            lanzarConfetti();
        }
    }, [ticket]);

    if (cargando) {
        return <div className="loader-fullscreen"><Loader /></div>;
    }

    return (
        <main className='ticket-creado site-width'>
            <div className="verificar-card tc-enter">

                {ticket ? (() => {
                    const esGestionTecnico = ticket.abierto_por && ticket.abierto_por !== ticket.usuario_creador;
                    const esTecnicoOAdmin = tokenInfo.role === 'admin' || tokenInfo.role === 'tecnico';

                    if (esGestionTecnico) {
                        // Técnico/admin creó el ticket en nombre de otro usuario
                        return (
                            <>
                                <div className="verificar-icon verificar-icon-exito tc-icon-pop"><FiCheckCircle /></div>
                                <h2>Ticket creado correctamente</h2>
                                <p>Has abierto un ticket en nombre de <strong>@{ticket.usuario_creador}</strong>. El usuario podrá ver y gestionar su ticket desde su panel.</p>
                                <IdentificadorChip valor={ticket.identificador} />
                                <p className='recordatorio'>El ticket ha quedado registrado y será atendido dentro de horario laboral.</p>
                                <Link to={`/ticket/${ticket.identificador}`} className='btn-ver-ticket'>Ver el ticket</Link>
                            </>
                        );
                    } else if (esTecnicoOAdmin) {
                        // Técnico/admin creó un ticket propio
                        return (
                            <>
                                <div className="verificar-icon verificar-icon-exito tc-icon-pop"><FiCheckCircle /></div>
                                <h2>Ticket creado correctamente</h2>
                                <p>El ticket ha sido registrado en el sistema y está disponible en el gestor de tickets.</p>
                                <IdentificadorChip valor={ticket.identificador} />
                                <Link to={`/ticket/${ticket.identificador}`} className='btn-ver-ticket'>Ver ticket</Link>
                            </>
                        );
                    } else {
                        // Usuario normal
                        return (
                            <>
                                <div className="verificar-icon verificar-icon-exito tc-icon-pop"><FiCheckCircle /></div>
                                <h2>Gracias por enviar tu ticket</h2>
                                <p className="tc-texto-principal">En breve la asignaremos a un técnico para que pueda ayudarte.</p>
                                <p className="tc-texto-secundario">Trabajamos por orden de llegada dentro de nuestro horario laboral, pero haremos todo lo posible por atenderte cuanto antes.</p>
                                <IdentificadorChip valor={ticket.identificador} />
                                <Link to={`/ticket/${ticket.identificador}`} className='btn-ver-ticket'>Ver mi ticket</Link>
                            </>
                        );
                    }
                })() : (
                    <>
                        <div className="verificar-icon verificar-icon-error tc-icon-pop"><FiAlertTriangle /></div>
                        <h2>¡Oops! No tienes permisos</h2>
                        <p>Si crees que este mensaje es un error, <a href='tel:+34 856 901 276'>contáctanos</a>.</p>
                    </>
                )}
            </div>
        </main>
    );
};

export default TicketCreado;
